import api from './api';

const vaultsqlService = {
  // Get all vault SQLs with optional filters
  getAllVaultSqls: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.vaultsourcegroupid) {
      params.append('vaultsourcegroupid', filters.vaultsourcegroupid);
    }
    if (filters.name) {
      params.append('name', filters.name);
    }
    const queryString = params.toString();
    const response = await api.get(`/vaultsql${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get a single vault SQL by ID
  getVaultSqlById: async (id) => {
    const response = await api.get(`/vaultsql/${id}`);
    return response.data;
  },

  // Create a new vault SQL
  createVaultSql: async (data) => {
    const response = await api.post('/vaultsql', data);
    return response.data;
  },

  // Update an existing vault SQL
  updateVaultSql: async (id, data) => {
    const response = await api.put(`/vaultsql/${id}`, data);
    return response.data;
  },

  // Delete a vault SQL
  deleteVaultSql: async (id) => {
    const response = await api.delete(`/vaultsql/${id}`);
    return response.data;
  }
};

export default vaultsqlService;
